import React, { useEffect, useState } from 'react';

const OfflineNotice: React.FC = () => {
    const [isOffline, setIsOffline] = useState(!navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOffline(false);
        const handleOffline = () => setIsOffline(true);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (!isOffline) return null;

    return (
        <div
            style={{
                backgroundColor: '#f44336',
                color: 'white',
                textAlign: 'center',
                padding: '5px 0',
                width: '100%',
            }}
        >
            Vous êtes hors connexion
        </div>
    );
};

export default OfflineNotice;
